import cn from 'classnames';
import styles from './ModalGallery.module.scss';
import { ModalFullScreen } from '../ModalFullScreen';
import { ArrowIcon } from '../Icons/ArrowIcon';
import { BLACK } from '@/constants/colors';
import { getBackendImage } from '@/utils/getBackendImage';

export type ModalGalleryProps = {
  galleryViewItem: number | null;
  setGalleryViewItem: (number: number | null) => void;
  gallery: string[];
  handlePrevImage: () => void;
  handleNextImage: () => void;
  className?: string;
};

export const ModalGallery = ({
  galleryViewItem,
  setGalleryViewItem,
  handlePrevImage,
  handleNextImage,
  gallery,
  className,
}: ModalGalleryProps) => {
  const wrapperClassName = cn(styles.wrapper, className);

  return (
    <ModalFullScreen
      opened={galleryViewItem !== null}
      closeFn={() => setGalleryViewItem(null)}
    >
      <div className={wrapperClassName}>
        <div className={styles.column}>
          {gallery.map((item: string, index: number) => (
            <img
              key={index}
              src={getBackendImage(item)}
              className={cn(styles.item, {
                [styles.itemActive]: galleryViewItem === index,
              })}
              alt="example"
              loading="lazy"
              onClick={() => setGalleryViewItem(index)}
            />
          ))}
        </div>
        <div className={styles.activeWrapper}>
          <img
            src={getBackendImage(gallery[galleryViewItem ?? 0])}
            className={styles.active}
            alt="example"
            loading="lazy"
          />
          <div className={styles.buttons}>
            <div className={styles.button} onClick={handlePrevImage}>
              <ArrowIcon color={BLACK} className={styles.left} />
            </div>
            <div className={styles.button} onClick={handleNextImage}>
              <ArrowIcon color={BLACK} className={styles.right} />
            </div>
          </div>
        </div>
      </div>
    </ModalFullScreen>
  );
};
